/**
 * Receiver Section
 * Receiver selection with Add/Invite buttons
 */

import { Select } from '@/components/base/select/select';
import { Button } from '@/components/base/buttons/button';
import { Plus } from '@untitledui/icons';
import type { ContainerFormData, SelectOption } from '@/hooks/useContainerForm';
import { useTranslation } from 'react-i18next';

interface ReceiverSectionProps {
    formData: ContainerFormData;
    onInputChange: (field: keyof ContainerFormData, value: string) => void;
    receiverOptions: SelectOption[];
    onAddReceiver: () => void;
    onInviteReceiver: () => void;
}

export function ReceiverSection({
    formData,
    onInputChange,
    receiverOptions,
    onAddReceiver,
    onInviteReceiver,
}: ReceiverSectionProps) {
    const { t } = useTranslation('pages:containers');

    return (
        <div className="rounded-xl bg-primary p-6 shadow-xs ring-1 ring-secondary">
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-lg font-semibold text-primary">{t('form.sections.receiver')}</h2>
                <div className="flex items-center gap-3">
                    <Button
                        type="button"
                        onClick={onAddReceiver}
                        size="sm"
                        color="secondary"
                        iconLeading={Plus}
                    >
                        {t('form.addReceiver', 'Add New')}
                    </Button>
                    <Button
                        type="button"
                        onClick={onInviteReceiver}
                        size="sm"
                        color="tertiary"
                    >
                        {t('form.inviteReceiver', 'Invite')}
                    </Button>
                </div>
            </div>
            <Select
                label={t('form.fields.receiver')}
                placeholder={t('form.fields.receiverPlaceholder')}
                items={receiverOptions}
                selectedKey={formData.consigneeCompanyId}
                onSelectionChange={(key) => onInputChange('consigneeCompanyId', key as string)}
                size="md"
            >
                {(item) => (
                    <Select.Item key={item.id} id={item.id}>
                        {item.label}
                    </Select.Item>
                )}
            </Select>
        </div>
    );
}
